import { useContext } from "react";
import { AuthContext } from "../contexts";
import { useLocalStorage } from "./useLocalStorage";
import { Session } from "../types";
import { sessionStorageKey } from "../consts";

export function useAuth() {
    const { ...auth } = useContext(AuthContext);

    const { storedValue: session } =
        useLocalStorage<Session>(sessionStorageKey);

    const { auth: localStorageAuth } = session || {};

    const isAuthenticated = () => {
        if (localStorageAuth && localStorageAuth?.user?.id) {
            return true;
        }
        return auth && auth?.user?.id;
    };

    const getConnectedUser = () => {
        if (isAuthenticated()) {
            if (auth && auth.user.id) {
                return {user : auth.user , currentUserRoleId : auth.currentUserRoleId };
            }
            return {user  : localStorageAuth?.user  , currentUserRoleId :localStorageAuth.currentUserRoleId };
        }
    };

    return {
        isAuthenticated,
        getConnectedUser,
    };
}
